import "common/coreDeps";
import app from "app/forms/application";
app.launch();
